import { contract as games } from "./games/v1alpha1";

export const contract = {
  games,
} as const;
